export default class VerifyUserTermError extends Error {
  constructor(message) {
    super(message);
    this.name = "VerifyUserTermError";
  }
}